<template>
  <component
    v-bind = "{ ...containerTag.props }"
    :is = "containerTag.name"
    :style = "containerTag.props && containerTag.props.style ? { ...containerTag.props.style, minHeight } : { minHeight }">
    <slot name = "before-name" />
    <component
      v-bind = "{...parrierTag.props, ...customBind.name || {} }"
      :is = "parrierTag.name">
      <v-text-field
        v-bind = "{ ...customBind.nameInput || {} , ...textFieldProps}"
        v-model = "input.name"
        placeholder = "Type Your Item Name" />
    </component>
    <slot name = "before-type" />
    <component
      v-bind = "{ ...parrierTag.props, ...customBind.type || {} }"
      :is = "parrierTag.name">
      <v-autocomplete
        :id = "`add-entities-${_uid}`"
        v-model="input.synonyms"
        v-bind = "{ ...customBind.typeInput || {} , ...textFieldProps}"
        :style = "{ minHeight }"
        :items="typeItems"
        placeholder = "Type Your Item Synonyms"
        no-data-text = "Press Enter To Add"
        box
        chips
        multiple/>
      <slot name = "after-type-component" />
    </component>
    <slot
      v-for = "(slot, s) in new Array(slots)"
      :name = "`tail-slot-${ s + 1 }`" />
  </component>
</template>

<script>
export default {
  name: 'EntitySublist',
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: 'tr',
          props: {
            class: ''
          }
        }
      }
    },
    heightFactor: {
      type: Number,
      default: 0.75
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: 'td',
          props: {
            class: ''
          }
        }
      }
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true
        }
      }
    },
    slots: {
      type: Number,
      default: 2
    },
    customBind: {
      type: Object,
      default() {
        return {}
      }
    },
    put: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isValid: false,
      input: {
        name: '',
        synonyms: []
      },
      typeItems: []
    }
  },
  computed: {
    minHeight() {
      return `${Math.max(
        parseInt(
          this.$_.sumBy(this.input.synonyms, e => e.length) * (( window.innerWidth / this.heightFactor )/ 500),
          10
        ),
        40
      )}px`
    }
  },
  watch: {
    put(val) {
      if (val) this.input = val
      else this.resetForm()
    }
  },
  mounted() {
    const vm = this
    setTimeout(() => {
      const selector = document.querySelector(`#add-entities-${this._uid}`)
      if (selector)
        selector.addEventListener('keydown', e => {
          window.s = selector
          if (e.keyCode === 13 && selector.value.length && vm.input.synonyms.indexOf(e.target.value) === -1) {
            vm.typeItems.push(e.target.value)
            vm.input.synonyms.push(e.target.value)
            setTimeout(() => {
              selector.value = ''
            }, 100)
          }
        })
    }, 1000)
  },
  methods: {
    handler(e) {
      // console.log(e)
    },
    async getEntity() {
      try {
        await this.$store.dispatch(
          'nlp/entities/get/single',
          this.$route.params.entity
        )
        await this.$store.dispatch(
          'nlp/entities/get/single/sublists',
          this.$route.params.entity
        )
        this.$store.state.nlp.sublists.forEach(sublist => {
          this.$store.dispatch('nlp/entities/get/single/synonyms', sublist.id)
        })
      } catch (err) {
        this.$store.dispatch('setErrorMessage', true)
      }
    },
    submit() {
      if (this.input.name.length && this.input.synonyms.length) {
        this.emitLoading(true)
        const payload = this.put
          ? { name: this.put.name, id: this.put.id }
          : { ...this.input }
        this.$store
          .dispatch(
            `nlp/entities/single/sublist/${this.put ? 'update' : 'add'}`,
            payload
          )
          .then(response => {
            this.getEntity()
            this.resetForm()
            this.emitLoading(false)
            this.$emit('success', response.data)
          })
          .catch(err => {
            this.emitLoading(false)
            if (err.response && err.response.status === 400) {
              this.$store.dispatch('setErrorMessage', err.response.data.error)
              this.getEntity()
            } else this.$store.dispatch('setErrorMessage', true)
            this.$emit('error', err)
          })
      }
    },
    async resetForm() {
      this.input = {
        name: '',
        synonyms: []
      }
      return true
    },
    emitLoading(status = true) {
      this.$emit('loading', status)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
